// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import Products from './pages/Products';
import Product from './pages/Product';
import AboutUs from './pages/Aboutus';
import Contact from './pages/Contact';
import Personalisation from './pages/Personalisation';
import Login from './pages/Admin/Login';
import Dashboard from './pages/Admin/Dashboard/Dashboard';
import { CartProvider } from './contexts/CartContext';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import NotFound from './pages/NotFound';


function App() {
  return (
    <CartProvider>
      <Router>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path='/Products' element={<Products />} />
              <Route path='/Products/:name' element={<Product />} />
              <Route path='/AboutUs' element={<AboutUs />} />
              <Route path='/Contact' element={<Contact />} />
              <Route path='/ArticlesPersonnalise' element={<Personalisation />} />
              {/* <Route path="/admin/login" element={<Login />} />
              <Route path="/admin/dashboard" element={<Dashboard />} /> */}

              <Route path='/admin/login' element={<Login />} />
              <Route path='/admin/dashboard' element={<Dashboard />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              
              {/* 404 - Must be last */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
